<template>
    <v-card>
        <v-card-title class="text-h5 mb-3">
            <strong>Productos resultados</strong>
            <v-spacer/>
            <v-btn
                class="text-capitalize mb-2 mb-sm-0 mr-2"
                :href="`/admin/export-products-results?dateInit=${dateInit}&dateEnd=${dateEnd}&filterTime=${filterTime}&filterAnalysis=${filterAnalysis}`"
            >
                <v-icon class="mr-2" color="green">mdi-file-excel</v-icon>
                Exportar
            </v-btn>
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col cols="12" sm="6">
                    <v-select
                        label="Tiempo"
                        outlined
                        dense
                        :items="itemsTimes"
                        item-text="name"
                        item-value="val"
                        v-model="filterTime"
                        @change="getData"
                    ></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                    <v-select
                        label="Analizar"
                        outlined
                        dense
                        :items="itemsAnalysis"
                        item-text="name"
                        item-value="val"
                        v-model="filterAnalysis"
                        @change="getData"
                    ></v-select>
                </v-col>
                <v-col cols="12" sm="6" v-if="filterTime=='custom'">
                    <v-menu
                        v-model="menu1"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="dateInit"
                                label="Fecha inicial"
                                prepend-icon="mdi-calendar"
                                readonly
                                outlined
                                dense
                                color="orange"
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="dateInit"
                            @input="menu1 = false, getData()"
                            locale="es"
                            color="primary"
                            class="ma-0"
                        ></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12" sm="6" v-if="filterTime=='custom'">
                    <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="dateEnd"
                                label="Fecha final"
                                prepend-icon="mdi-calendar"
                                readonly
                                outlined
                                dense
                                color="orange"
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="dateEnd"
                            @input="menu2 = false, getData()"
                            locale="es"
                            color="primary"
                            class="ma-0"
                        ></v-date-picker>
                    </v-menu>
                </v-col>
            </v-row>

            <v-divider/>

            <v-simple-table v-if="!loading">
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th>
                                <v-chip
                                    color="primary"
                                    outlined
                                >
                                    <strong>TOTAL</strong>
                                </v-chip>
                            </th>
                            <th class="text-end"><strong class="font-weight-black body-1">{{ totalQuantity }}</strong></th>
                            <th class="text-end"><strong class="font-weight-black body-1">{{ ((totalQuantity>0) ? totalSales/totalQuantity : 0).toFixed(numberDecimals) }}</strong></th>
                            <th class="text-end"><strong class="font-weight-black body-1">{{ totalUnitCost.toFixed(numberDecimals) }}</strong></th>
                            <th class="text-end"><strong class="font-weight-black body-1">{{ totalUnitGain.toFixed(numberDecimals) }}</strong></th>
                            <th class="text-end"><strong class="font-weight-black body-1">{{ totalSales.toFixed(numberDecimals) }}</strong></th>
                            <th class="text-end"><strong class="font-weight-black body-1">{{ totalCost.toFixed(numberDecimals) }}</strong></th>
                            <th class="text-end"><strong class="font-weight-black body-1">{{ totalGain.toFixed(numberDecimals) }}</strong></th>
                        </tr>
                        <tr>
                            <th>
                                <div class="d-flex align-center">
                                    <span>Producto</span>
                                    <div class="wrap-order">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <span class="order-up"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click="orderType='DESC', orderBy='name', getData()"
                                                ></span>
                                            </template>
                                            <span>Orden descendente</span>
                                        </v-tooltip>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <span class="order-down"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click="orderType='ASC', orderBy='name', getData()"
                                                ></span>
                                            </template>
                                            <span>Orden ascendente</span>
                                        </v-tooltip>
                                    </div>
                                    <v-menu offset-y :close-on-content-click="false">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                            color="primary"
                                            dark
                                            icon
                                            small
                                            v-bind="attrs"
                                            v-on="on"
                                            >
                                                <v-icon>mdi-filter</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-card>
                                            <v-card-text>
                                                <form @submit.prevent="processSearch">
                                                    <v-text-field
                                                        v-model="txtName"
                                                        label="Venta"
                                                        outlined
                                                        dense
                                                        hide-details
                                                        type="text"
                                                    ></v-text-field>
                                                    <div class="text-right mt-4">
                                                        <v-btn
                                                            color="primary"
                                                            type="submit"
                                                            flat
                                                            small
                                                        >
                                                            <v-icon>mdi-magnify</v-icon>
                                                        </v-btn>
                                                        <v-btn
                                                            color="red"
                                                            text
                                                            small
                                                            @click="cleanSearch('name')"
                                                        >
                                                            Limpiar
                                                        </v-btn>
                                                    </div>
                                                </form>
                                            </v-card-text>
                                        </v-card>
                                    </v-menu>
                                </div>
                            </th>
                            <th>
                                <div class="d-flex align-center">
                                    <span>Cantidad</span>
                                    <div class="wrap-order">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <span class="order-up"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click="orderType='DESC', orderBy='quantity', getData()"
                                                ></span>
                                            </template>
                                            <span>Orden descendente</span>
                                        </v-tooltip>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <span class="order-down"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click="orderType='ASC', orderBy='quantity', getData()"
                                                ></span>
                                            </template>
                                            <span>Orden ascendente</span>
                                        </v-tooltip>
                                    </div>
                                    <v-menu offset-y :close-on-content-click="false">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                            color="primary"
                                            dark
                                            icon
                                            small
                                            v-bind="attrs"
                                            v-on="on"
                                            >
                                                <v-icon>mdi-filter</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-card>
                                            <v-card-text>
                                                <form @submit.prevent="processSearch">
                                                    <v-text-field
                                                        v-model="txtQuantity"
                                                        label="Cantidad"
                                                        outlined
                                                        dense
                                                        hide-details
                                                        type="number"
                                                    ></v-text-field>
                                                    <div class="text-right mt-4">
                                                        <v-btn
                                                            color="primary"
                                                            type="submit"
                                                            flat
                                                            small
                                                        >
                                                            <v-icon>mdi-magnify</v-icon>
                                                        </v-btn>
                                                        <v-btn
                                                            color="red"
                                                            text
                                                            small
                                                            @click="cleanSearch('quantity')"
                                                        >
                                                            Limpiar
                                                        </v-btn>
                                                    </div>
                                                </form>
                                            </v-card-text>
                                        </v-card>
                                    </v-menu>
                                </div>
                            </th>
                            <th>
                                <div class="d-flex align-center">
                                    <span>Precio unitario</span>
                                    <div class="wrap-order">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <span class="order-up"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click="orderType='DESC', orderBy='price', getData()"
                                                ></span>
                                            </template>
                                            <span>Orden descendente</span>
                                        </v-tooltip>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <span class="order-down"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click="orderType='ASC', orderBy='price', getData()"
                                                ></span>
                                            </template>
                                            <span>Orden ascendente</span>
                                        </v-tooltip>
                                    </div>
                                    <v-menu offset-y :close-on-content-click="false">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                            color="primary"
                                            dark
                                            icon
                                            small
                                            v-bind="attrs"
                                            v-on="on"
                                            >
                                                <v-icon>mdi-filter</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-card>
                                            <v-card-text>
                                                <form @submit.prevent="processSearch">
                                                    <v-text-field
                                                        v-model="txtPrice"
                                                        label="Precio"
                                                        outlined
                                                        dense
                                                        hide-details
                                                        type="number"
                                                    ></v-text-field>
                                                    <div class="text-right mt-4">
                                                        <v-btn
                                                            color="primary"
                                                            type="submit"
                                                            flat
                                                            small
                                                        >
                                                            <v-icon>mdi-magnify</v-icon>
                                                        </v-btn>
                                                        <v-btn
                                                            color="red"
                                                            text
                                                            small
                                                            @click="cleanSearch('price')"
                                                        >
                                                            Limpiar
                                                        </v-btn>
                                                    </div>
                                                </form>
                                            </v-card-text>
                                        </v-card>
                                    </v-menu>
                                </div>
                            </th>
                            <th>
                                <div class="d-flex align-center">
                                    <span>Costo unitario</span>
                                    <div class="wrap-order">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <span class="order-up"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click="orderType='DESC', orderBy='unit_cost', getData()"
                                                ></span>
                                            </template>
                                            <span>Orden descendente</span>
                                        </v-tooltip>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <span class="order-down"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click="orderType='ASC', orderBy='unit_cost', getData()"
                                                ></span>
                                            </template>
                                            <span>Orden ascendente</span>
                                        </v-tooltip>
                                    </div>
                                    <v-menu offset-y :close-on-content-click="false">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                            color="primary"
                                            dark
                                            icon
                                            small
                                            v-bind="attrs"
                                            v-on="on"
                                            >
                                                <v-icon>mdi-filter</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-card>
                                            <v-card-text>
                                                <form @submit.prevent="processSearch">
                                                    <v-text-field
                                                        v-model="txtUnitCost"
                                                        label="Costo unitario"
                                                        outlined
                                                        dense
                                                        hide-details
                                                        type="number"
                                                    ></v-text-field>
                                                    <div class="text-right mt-4">
                                                        <v-btn
                                                            color="primary"
                                                            type="submit"
                                                            flat
                                                            small
                                                        >
                                                            <v-icon>mdi-magnify</v-icon>
                                                        </v-btn>
                                                        <v-btn
                                                            color="red"
                                                            text
                                                            small
                                                            @click="cleanSearch('unit_cost')"
                                                        >
                                                            Limpiar
                                                        </v-btn>
                                                    </div>
                                                </form>
                                            </v-card-text>
                                        </v-card>
                                    </v-menu>
                                </div>
                            </th>
                            <th>
                                <div class="d-flex align-center">
                                    <span>Ganancia  unitaria</span>
                                    <div class="wrap-order">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <span class="order-up"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click="orderType='DESC', orderBy='unit_gain', getData()"
                                                ></span>
                                            </template>
                                            <span>Orden descendente</span>
                                        </v-tooltip>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <span class="order-down"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click="orderType='ASC', orderBy='unit_gain', getData()"
                                                ></span>
                                            </template>
                                            <span>Orden ascendente</span>
                                        </v-tooltip>
                                    </div>
                                    <v-menu offset-y :close-on-content-click="false">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                            color="primary"
                                            dark
                                            icon
                                            small
                                            v-bind="attrs"
                                            v-on="on"
                                            >
                                                <v-icon>mdi-filter</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-card>
                                            <v-card-text>
                                                <form @submit.prevent="processSearch">
                                                    <v-text-field
                                                        v-model="txtUnitGain"
                                                        label="Ganancia unitaria"
                                                        outlined
                                                        dense
                                                        hide-details
                                                        type="number"
                                                    ></v-text-field>
                                                    <div class="text-right mt-4">
                                                        <v-btn
                                                            color="primary"
                                                            type="submit"
                                                            flat
                                                            small
                                                        >
                                                            <v-icon>mdi-magnify</v-icon>
                                                        </v-btn>
                                                        <v-btn
                                                            color="red"
                                                            text
                                                            small
                                                            @click="cleanSearch('unit_gain')"
                                                        >
                                                            Limpiar
                                                        </v-btn>
                                                    </div>
                                                </form>
                                            </v-card-text>
                                        </v-card>
                                    </v-menu>
                                </div>
                            </th>
                            <th>
                                <div class="d-flex align-center">
                                    <span>Venta total</span>
                                    <div class="wrap-order">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <span class="order-up"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click="orderType='DESC', orderBy='total', getData()"
                                                ></span>
                                            </template>
                                            <span>Orden descendente</span>
                                        </v-tooltip>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <span class="order-down"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click="orderType='ASC', orderBy='total', getData()"
                                                ></span>
                                            </template>
                                            <span>Orden ascendente</span>
                                        </v-tooltip>
                                    </div>
                                    <v-menu offset-y :close-on-content-click="false">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                            color="primary"
                                            dark
                                            icon
                                            small
                                            v-bind="attrs"
                                            v-on="on"
                                            >
                                                <v-icon>mdi-filter</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-card>
                                            <v-card-text>
                                                <form @submit.prevent="processSearch">
                                                    <v-text-field
                                                        v-model="txtTotal"
                                                        label="Valor venta"
                                                        outlined
                                                        dense
                                                        hide-details
                                                        type="number"
                                                    ></v-text-field>
                                                    <div class="text-right mt-4">
                                                        <v-btn
                                                            color="primary"
                                                            type="submit"
                                                            flat
                                                            small
                                                        >
                                                            <v-icon>mdi-magnify</v-icon>
                                                        </v-btn>
                                                        <v-btn
                                                            color="red"
                                                            text
                                                            small
                                                            @click="cleanSearch('total')"
                                                        >
                                                            Limpiar
                                                        </v-btn>
                                                    </div>
                                                </form>
                                            </v-card-text>
                                        </v-card>
                                    </v-menu>
                                </div>
                            </th>
                            <th>
                                <div class="d-flex align-center">
                                    <span>Costo Total</span>
                                    <div class="wrap-order">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <span class="order-up"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click="orderType='DESC', orderBy='total_cost', getData()"
                                                ></span>
                                            </template>
                                            <span>Orden descendente</span>
                                        </v-tooltip>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <span class="order-down"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click="orderType='ASC', orderBy='total_cost', getData()"
                                                ></span>
                                            </template>
                                            <span>Orden ascendente</span>
                                        </v-tooltip>
                                    </div>
                                    <v-menu offset-y :close-on-content-click="false">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                            color="primary"
                                            dark
                                            icon
                                            small
                                            v-bind="attrs"
                                            v-on="on"
                                            >
                                                <v-icon>mdi-filter</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-card>
                                            <v-card-text>
                                                <form @submit.prevent="processSearch">
                                                    <v-text-field
                                                        v-model="txtTotalCost"
                                                        label="Costo total"
                                                        outlined
                                                        dense
                                                        hide-details
                                                        type="number"
                                                    ></v-text-field>
                                                    <div class="text-right mt-4">
                                                        <v-btn
                                                            color="primary"
                                                            type="submit"
                                                            flat
                                                            small
                                                        >
                                                            <v-icon>mdi-magnify</v-icon>
                                                        </v-btn>
                                                        <v-btn
                                                            color="red"
                                                            text
                                                            small
                                                            @click="cleanSearch('total_cost')"
                                                        >
                                                            Limpiar
                                                        </v-btn>
                                                    </div>
                                                </form>
                                            </v-card-text>
                                        </v-card>
                                    </v-menu>
                                </div>
                            </th>
                            <th>
                                <div class="d-flex align-center">
                                    <span>Ganancia Total</span>
                                    <div class="wrap-order">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <span class="order-up"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click="orderType='DESC', orderBy='total_gain', getData()"
                                                ></span>
                                            </template>
                                            <span>Orden descendente</span>
                                        </v-tooltip>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <span class="order-down"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click="orderType='ASC', orderBy='total_gain', getData()"
                                                ></span>
                                            </template>
                                            <span>Orden ascendente</span>
                                        </v-tooltip>
                                    </div>
                                    <v-menu offset-y :close-on-content-click="false">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                            color="primary"
                                            dark
                                            icon
                                            small
                                            v-bind="attrs"
                                            v-on="on"
                                            >
                                                <v-icon>mdi-filter</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-card>
                                            <v-card-text>
                                                <form @submit.prevent="processSearch">
                                                    <v-text-field
                                                        v-model="txtTotalGain"
                                                        label="Ganancia Total"
                                                        outlined
                                                        dense
                                                        hide-details
                                                        type="number"
                                                    ></v-text-field>
                                                    <div class="text-right mt-4">
                                                        <v-btn
                                                            color="primary"
                                                            type="submit"
                                                            flat
                                                            small
                                                        >
                                                            <v-icon>mdi-magnify</v-icon>
                                                        </v-btn>
                                                        <v-btn
                                                            color="red"
                                                            text
                                                            small
                                                            @click="cleanSearch('total_gain')"
                                                        >
                                                            Limpiar
                                                        </v-btn>
                                                    </div>
                                                </form>
                                            </v-card-text>
                                        </v-card>
                                    </v-menu>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in dataResult" :key="index">
                            <td>{{ item.name }}</td>
                            <td class="text-end">
                                {{ item.quantity }}
                            </td>
                            <td class="text-end">
                                {{ ((item.special_price && item.special_price > 0)? item.special_price : item.price).toFixed(numberDecimals) }}
                                <!-- {{ (item.quantity && item.quantity > 0)? (item.total / item.quantity).toFixed(2) : 0 }} -->
                            </td>
                            <td class="text-end">{{ item.unit_cost.toFixed(numberDecimals) }}</td>
                            <td class="text-end">{{ item.unit_gain.toFixed(numberDecimals)}}</td>
                            <td class="text-end">
                                {{ (item.total).toFixed(numberDecimals) }}
                            </td>
                            <td class="text-end">{{ item.total_cost.toFixed(numberDecimals) }}</td>
                            <td class="text-end">{{ item.total_gain.toFixed(numberDecimals) }}</td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            itemsTimes: [
                {val: 'day', name: 'Día actual'},
                {val: 'week', name: 'Semana actual'},
                {val: 'month', name: 'Mes actual'},
                {val: 'year', name: 'Año actual'},
                {val: 'custom', name: 'Personalizado'},
            ],
            filterTime: 'month',
            itemsAnalysis:[
                {val: 'physical', name: 'Tienda física'},
                {val: 'virtual', name: 'Tienda virtual'},
                {val: 'both', name: 'Tienda virtual + fisica'},
            ],
            filterAnalysis: 'both',
            menu1: false,
            menu2: false,
            dateInit: '',
            dateEnd: '',
            // results
            dataResult: {},
            orderType: 'DESC',
            orderBy: 'id',
            txtName: '',
            txtPrice: '',
            txtQuantity: '',
            txtTotal: '',
            txtUnitCost: '',
            txtUnitGain: '',
            txtTotalCost: '',
            txtTotalGain: '',
            totalQuantity: 0,
            totalSales: 0,
            totalUnitCost: 0,
            totalUnitGain: 0,
            totalCost: 0,
            totalGain: 0,
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        processSearch () {
            // this.page = 1
            this.getData()
        },
        cleanSearch (type='') {
            switch (type) {
                case 'name':
                    this.txtName = ''
                    this.getData();
                    break;
                case 'price':
                    this.txtPrice = ''
                    this.getData();
                    break;
                case 'quantity':
                    this.txtQuantity = ''
                    this.getData();
                    break;
                case 'total':
                    this.txtTotal = ''
                    this.getData();
                    break;
                case 'unit_cost':
                    this.txtUnitCost = ''
                    this.getData();
                    break;
                case 'unit_gain':
                    this.txtUnitGain = ''
                    this.getData();
                    break;
                case 'total_cost':
                    this.txtTotalCost = ''
                    this.getData();
                    break;
                case 'total_gain':
                    this.txtTotalGain = ''
                    this.getData();
                    break;
                default:
                    this.getData();
                    break;
            }
        },
        async getData() {
            this.loading = true
            this.totalQuantity = 0
            this.totalSales = 0
            this.totalUnitCost = 0
            this.totalUnitGain = 0
            this.totalCost = 0
            this.totalGain = 0
            await axios.post(`/admin/get-products-results?orderby=${this.orderBy}&ordertype=${this.orderType}&name=${this.txtName}&price=${this.txtPrice}&quantity=${this.txtQuantity}&total=${this.txtTotal}&unit_cost=${this.txtUnitCost}&unit_gain=${this.txtUnitGain}&total_cost=${this.txtTotalCost}&total_gain=${this.txtTotalGain}`, {
                filterTime: this.filterTime,
                filterAnalysis: this.filterAnalysis,
                dateInit: this.dateInit,
                dateEnd: this.dateEnd
            })
            .then((response) => {
                // console.log(response);
                this.dataResult = response.data

                for (const [key, value] of Object.entries(this.dataResult)) {
                    this.totalQuantity += (+value.quantity)
                    this.totalSales += (+value.total)
                    this.totalUnitCost += (+value.unit_cost)
                    this.totalUnitGain += (+value.unit_gain)
                    this.totalCost += (+value.total_cost)
                    this.totalGain += (+value.total_gain)
                }
            })
            .catch((error) => {
                // console.log(error);
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
            })
            .finally(() => {
                setTimeout(() => {
                    this.loading = false
                }, 300);
            })
        }
    },
    computed: {
        numberDecimals () {
            return this.$store.state.numberDecimals.numberDecimals
        }
    },
}
</script>
